
// Function to fetch the top 5 genres and sum the rest into "Other"
export function getTopGenres(genreData, topK = 5) {
    // Convert the object into an array of { genre, value } pairs
    const genreArray = Object.entries(genreData).map(([genre, value]) => ({ genre, value }));

    // Sort the array by value in descending order. A genre literally tagged
    // "Other" folds into the leftover bucket below, so the legend never lists
    // "Other" twice.
    const sortedGenres = genreArray
        .filter((g) => g.genre.trim().toLowerCase() !== 'other')
        .sort((a, b) => b.value - a.value);
    const taggedOther = genreArray
        .filter((g) => g.genre.trim().toLowerCase() === 'other')
        .reduce((sum, g) => sum + g.value, 0);

    // Take the top K genres
    const topGenres = sortedGenres.slice(0, topK);

    // Sum up the rest into "Other"
    const otherCount = taggedOther + sortedGenres.slice(topK).reduce((sum, genre) => sum + genre.value, 0);

    // Add "Other" to the top genres if there are remaining genres
    if (otherCount > 0) {
        topGenres.push({ genre: "Other", value: otherCount });
    }

    return topGenres;
}

// Example: Update and fetch

// const genreData = {
//     trance: 123,
//     techno: 111,
//     house: 90,
//     jazz: 80,
//     hiphop: 70,
//     rock: 50,
//     pop: 30,
// };
//
// (function () {
//     const result = getTopGenres(genreData, 5);
//
//     console.log(result);
// })();

